import { UserManagerSettings } from "oidc-client";

export interface IdSvrPreAuthOptions {
    clientInfoApiUrl: string;
    accessTokenSessionKey: string;
    onSuccessCallback?: () => void;
    onFailCallback?: () => void;
}

export interface ClientInfo {
    authorityUrl: string;
    clientId: string;
    clientUrl: string;
}

export interface Token {
    iss: string;
    aud: string;
    exp: number;
    nbf: number;
    client_id: string;
    scope: string[];
    sub: string[];
    auth_time: number;
    idp: string;
    id: string;
    name: string;
    profile: string;
    amr: string[];
}

export interface UserModule {
    Id: string;
    Permissions: string[];
}

export interface Profile {
    UserId: number;
    Login: string;
    FullName: string;
    Email: string;
    UserModules: UserModule[];
    UserSubstitutions: any[];
}

export interface IdentityAuthOptions {
    userManagerOptions?: UserManagerSettings;
    postLogoutRedirectUrl?: string;
  }
  
  export const IdentityServerConfig = {
    AccessTokenKey: "IdSvr.AccessToken",
    ClientInfoKey: "IdSvr.ClientInfo",
    ClientInfoApiUrl: "api/identity/clientinfo"
};